module.exports = __webpack_public_path__ + "static/img/apiimg1.691ed8f7.svg";